import {
  TOASTER_ADD_DANGER,
  TOASTER_ADD_INFO,
  TOASTER_ADD_SUCCESS,
  TOASTER_ADD_WARNING,
} from 'containers/Toaster/constants';
import { put, select } from 'redux-saga/effects';

import { selectLanguage } from 'containers/LanguageProvider/selectors';
import get from 'lodash/get';
import { translations } from 'translations/translations';

const messageType = (type) => {
  switch (type) {
    case 'danger':
      return TOASTER_ADD_DANGER;
    case 'success':
      return TOASTER_ADD_SUCCESS;
    case 'info':
      return TOASTER_ADD_INFO;
    case 'warning':
      return TOASTER_ADD_WARNING;
    default:
      return TOASTER_ADD_INFO;
  }
};

export function* displayMessage(
  type,
  path,
  additionalMessage,
  replaceFn = (t) => t,
  flashOnly = false,
) {
  const language = yield select(selectLanguage);
  const messages = translations(language.get('locale'));
  yield put({
    type: messageType(type),
    payload: {
      message: replaceFn(`${get(messages, path)}${additionalMessage || ''}`),
      flashOnly,
    },
  });
}
